import React from "react";
import { ReactComponent as EagerDogSVG } from "../../assets/eagerdog.svg";
import "./Loading.scss";

interface LoadingProps {
  message?: string;
  size?: "small" | "medium" | "large";
  fullScreen?: boolean;
}

const Loading: React.FC<LoadingProps> = ({
  message = "Loading...",
  size = "medium",
  fullScreen = true
}) => {
  const containerClass = `loading-container ${fullScreen ? "loading-fullscreen" : "loading-inline"}`;
  const logoClass = `loading-logo loading-logo-${size}`;

  return (
    <div className={containerClass}>
      <div className="loading-content">
        <div className={logoClass}>
          <EagerDogSVG className="loading-svg" />
        </div>
        <div className="loading-text">{message}</div>
      </div>
    </div>
  );
};

export default Loading; 